import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';
import { BookOpen, Download, Eye } from 'lucide-react';
import { API, FileBadge, dt, fileSize, openFile } from '../components/doc-library/docLibShared';
import { DocFilters, filterDocs, countByCat } from '../components/doc-library/DocFilters';

const DocRow = ({ d, cat, onOpened }) => {
  const go = async (download) => {
    try { await openFile(`${API}/firm/documents/${d.id}/file`, d.name, download); onOpened(); } catch { toast.error('Dosya açılamadı'); }
  };
  return (
    <Card className={`transition-shadow hover:shadow-md ${d.is_new ? 'border-orange-300' : 'border-slate-200'}`} data-testid={`firm-doc-${d.id}`}>
      <CardContent className="flex items-center gap-3 p-4">
        <FileBadge type={d.content_type} />
        <button type="button" onClick={() => go(false)} className="min-w-0 flex-1 text-left">
          <span className="flex items-center gap-2">
            <span className="truncate font-semibold text-slate-900">{d.title}</span>
            {d.is_new && <span className="rounded-full bg-orange-500 px-2 py-0.5 text-[11px] font-bold text-white" data-testid={`firm-doc-new-${d.id}`}>{d.version > 1 ? 'Güncellendi' : 'Yeni'}</span>}
          </span>
          <span className="block text-xs text-slate-500">{cat} · v{d.version} · {fileSize(d.size)} · {dt(d.updated_at)}{d.note ? ` · ${d.note}` : ''}</span>
        </button>
        <button type="button" onClick={() => go(false)} className="rounded-md p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-800" title="Görüntüle" data-testid={`firm-doc-open-${d.id}`}><Eye className="h-4 w-4" /></button>
        <button type="button" onClick={() => go(true)} className="rounded-md p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-800" title="İndir" data-testid={`firm-doc-download-${d.id}`}><Download className="h-4 w-4" /></button>
      </CardContent>
    </Card>
  );
};

export default function FirmDocumentsPage() {
  const [docs, setDocs] = useState(null);
  const [categories, setCategories] = useState([]);
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('');
  const load = () => axios.get(`${API}/firm/documents`).then(r => setDocs(r.data)).catch(() => setDocs([]));
  useEffect(() => { load(); axios.get(`${API}/doc-library/categories`).then(r => setCategories(r.data)).catch(() => {}); }, []);
  const opened = () => { load(); window.dispatchEvent(new Event('docs:count')); };
  const used = categories.filter(c => (docs || []).some(d => d.category_id === c.id));
  const shown = filterDocs(docs || [], q, cat);
  const fresh = (docs || []).filter(d => d.is_new).length;
  return (
    <div className="space-y-6 max-w-4xl" data-testid="firm-documents-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><BookOpen className="h-6 w-6 text-orange-500" />Dokümanlar</h1>
        <p className="text-slate-500 mt-1">Prosedür, form ve talimatlara buradan ulaşabilirsiniz. Her zaman en güncel sürüm gösterilir.{fresh > 0 && <b className="text-orange-600"> {fresh} yeni / güncellenmiş doküman var.</b>}</p>
      </div>
      <DocFilters q={q} setQ={setQ} cat={cat} setCat={setCat} categories={used} counts={countByCat(docs || [])} />
      {docs === null ? <p className="text-slate-400">Yükleniyor...</p>
        : shown.length === 0 ? <Card className="border-dashed"><CardContent className="p-10 text-center text-slate-500" data-testid="firm-doc-empty">{docs.length ? 'Aramanıza uygun doküman yok.' : 'Henüz doküman yok.'}</CardContent></Card>
          : <div className="space-y-3">{shown.map(d => <DocRow key={d.id} d={d} cat={categories.find(c => c.id === d.category_id)?.name || '-'} onOpened={opened} />)}</div>}
    </div>
  );
}
